export default class ComponentFactory {
    // #region Vars
    _app;
    _componentRegistry = new Map();
    // #endregion
    // #region Properties
    //fileFilter?: RegExp = /(?<!views)\.vue$/;
    // #endregion
    // #region Constructor
    constructor(app) {
        this._app = app;
    }
    // #endregion
    // #region Common
    getComponentRegistry() {
        return this._componentRegistry;
    }
    // #endregion
    // #region Properties
    getComponent(name) {
        return this._app.component(name);
    }
    load(Components) {
        Components.forEach((e) => {
            if (utils.isNullOrEmpty(e.name)) {
                utils.logWarning("No name is provided for component.", e);
                return;
            }
            if (this._componentRegistry.has(e.name)) {
                this._componentRegistry.delete(e.name);
            }
            this._componentRegistry.set(e.name, e);
        });
    }
    loadSingle(component) {
        if (utils.isNullOrEmpty(component.name)) {
            utils.logWarning("No name is provided for component.", component);
            return;
        }
        if (this._componentRegistry.has(component.name)) {
            this._componentRegistry.delete(component.name);
        }
        this._componentRegistry.set(component.name, component);
    }
    registerAll(context) {
        context.keys().forEach(e => {
            //View
            let tView = context(e).default;
            //Append
            this.loadSingle(tView);
        });
    }
}
